export const TwoFAForm = ({ twofa, code, onCodeChange, err, loading, onSubmit, onBack }) => (
  <form onSubmit={onSubmit} className="space-y-4" data-testid="twofa-form">
    <div>
      <h2 className="font-display text-2xl font-bold mb-1" style={{ color: "var(--text-primary)" }}>
        Check your email
      </h2>
      <p className="text-sm" style={{ color: "var(--text-secondary)" }} data-testid="twofa-hint">
        We sent a 6-digit code to {twofa.email_hint}. Enter it below to finish signing in.
      </p>
    </div>
    <div>
      <label className="field-label">Verification code</label>
      <input
        className="field-input text-center text-2xl tracking-[0.5em] font-mono"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        value={code}
        onChange={(e) => onCodeChange(e.target.value.replace(/\D/g, ""))}
        autoFocus
        data-testid="twofa-code-input"
      />
    </div>
    {err && <div className="text-sm" style={{ color: "#B04A1A" }} data-testid="twofa-error">{err}</div>}
    <button type="submit" className="btn-primary w-full" disabled={loading || code.length !== 6}
      data-testid="twofa-verify-btn">
      {loading ? "Verifying…" : "Verify & sign in"}
    </button>
    <button type="button" className="btn-ghost w-full text-sm" onClick={onBack}
      data-testid="twofa-back-btn">
      Back to sign in
    </button>
  </form>
);
